import {gql} from '@apollo/client'

export type ChildcareMethod = 'new' | 'from_past'

export const CHILDCARE_METHOD_SELECT_NAME = 'childcare_method_select'

export const UPDATE_CHILDCARE_METHOD_SELECT = gql`
  mutation updateChildcareMethodSelect($input: UpdateProcedureTmpDatumInput!) {
    updateProcedureTmpDatum(input: $input) {
      procedureStatus {
        id
      }
    }
  }
`

export interface UpdateChildcareMethodSelectQueryVariables {
  input: {
    procedureStatusId: string
    type: 'draft' | 'employee_draft'
    name: typeof CHILDCARE_METHOD_SELECT_NAME
    data: {method: ChildcareMethod}
  }
}
